export const homeData = [
  {
    id: 1,
    name: "Sand Dust",
    rating: 4.7,
    time: "2hr : 22mins",
    desc: "Sand and dust storms (SDS), also known as sirocco, haboob, yellow dust, white storms, and the harmattan, are a natural phenomenon linked with land and water management and climate change.",
    starring: "Karen Gilchrist, James Earl Jones",
    genres: "Action",
    tags: "Action, Adventures, Horror",
    cover: "../images/home1.jpg",
    video: "../video/video1.mp4",
    date: "20-Jan-1997",
  },
  {
    id: 2,
    name: "skull island",
    rating: 4.6,
    time: "2hr : 22mins",
    desc: "The island, like its inhabitants, is wholly fictional. Kong's island home in the Pacific makes its first appearance, along with Kong himself, in the 1933 film King Kong. ",
    starring: "Brenda Chapman, Jeff Nathanson",
    genres: "Adventures",
    tags: "Adventures,Animation,Family",
    cover: "../images/home2.jpg",
    video: "../video/video2.mp4",
    date: "10-JUL-2021",
  },
  {
    id: 3,
    name: "Pirates Sea",
    rating: 4.8,
    time: "2hr : 22mins",
    desc: "Piracy is an act of robbery or criminal violence by ship or boat-borne attackers upon another ship or a coastal area, typically with the goal of stealing cargo and other valuable items or properties. ",
    starring: "James Chinlund, Jeff Nathanson",
    genres: "Adventures",
    tags: "Adventures,Action ",
    cover: "../images/home3.jpg",
    video: "../video/video3.mp4",
    date: "20-FEB-2010",
  },
  {
    id: 4,
    name: "Sand Dust",
    rating: 4.9,
    time: "2hr : 22mins",
    desc: "Sand and dust storms (SDS), also known as sirocco, haboob, yellow dust, white storms, and the harmattan, are a natural phenomenon linked with land and water management and climate change.",
    starring: "Karen Gilchrist, James Earl Jones",
    genres: "Action",
    tags: "Action, Adventures, Horror",
    cover: "../images/home4.jpg",
    video: "../video/video4.mp4",
    date: "12-Aug-2015",
  },
]
export const upcome = [
  {
    id: 1,
    cover: "../images/upcome/u1.jpg",
    name: "My office Boss",
    time: "2hr : 38mins",
  },
  {
    id: 2,
    cover: "../images/upcome/u2.jpg",
    name: "Shadowe",
    time: "2hr : 38mins",
  },
  {
    id: 3,
    cover: "../images/upcome/u3.jpg",
    name: "Another Danger",
    time: "2hr : 38mins",
  },
  {
    id: 4,
    cover: "../images/upcome/u4.jpg",
    name: "One Man Army",
    time: "2hr : 38mins",
  },
  {
    id: 5,
    cover: "../images/upcome/u5.jpg",
    name: "Jumbo Queen",
    time: "2hr : 38mins",
  },
]
export const latest = [
  {
    id: 1,
    cover: "../images/upcome/u6.png",
    name: "King of Jungle",
    time: "2hr : 38mins",
  },
  {
    id: 2,
    cover: "../images/upcome/u7.jpg",
    name: "The illusion",
    time: "2hr : 38mins",
  },
  {
    id: 3,
    cover: "../images/upcome/u1.jpg",
    name: "Latest Movie",
    time: "2hr : 38mins",
  },
  {
    id: 4,
    cover: "../images/upcome/u5.jpg",
    name: "Latest two",
    time: "2hr : 38mins",
  },
  {
    id: 5,
    cover: "../images/upcome/u4.jpg",
    name: "Latest Three",
    time: "2hr : 38mins",
  },
]

export const trending = [
  {
    id: 1,
    name: "The Dinosaur",
    rating: 4.7,
    time: "2hr : 22mins",
    desc: "Sand and dust storms (SDS), also known as sirocco, haboob, yellow dust, white storms, and the harmattan, are a natural phenomenon linked with land and water management and climate change.",
    starring: "Karen Gilchrist, James Earl Jones",
    genres: "Action",
    tags: "Action, Adventures, Horror",
    cover: "../images/img/slide1.png",
    date: "20-Jan-1997",
  },
  {
    id: 2,
    name: "The Great Emperor",
    rating: 4.6,
    time: "2hr : 22mins",
    desc: "The island, like its inhabitants, is wholly fictional. Kong's island home in the Pacific makes its first appearance, along with Kong himself, in the 1933 film King Kong. ",
    starring: "Brenda Chapman, Jeff Nathanson",
    genres: "Adventures",
    tags: "Adventures,Animation,Family",
    cover: "../images/img/slide2.jpg",
    date: "10-JUL-2021",
  },
  {
    id: 3,
    name: "Jumbo Queen",
    rating: 4.8,
    time: "2hr : 22mins",
    desc: "Piracy is an act of robbery or criminal violence by ship or boat-borne attackers upon another ship or a coastal area, typically with the goal of stealing cargo and other valuable items or properties. ",
    starring: "James Chinlund, Jeff Nathanson",
    genres: "Adventures",
    tags: "Adventures,Action ",
    cover: "../images/img/slide3.jpg",
    date: "20-FEB-2010",
  },
]
export const recommended = [
  {
    id: 4,
    cover: "../images/rec/rec1.jpg",
    name: "One Man Army",
    time: "2hr : 38mins",
  },
  {
    id: 5,
    cover: "../images/rec/rec2.jpg",
    name: "Jumbo Queen",
    time: "2hr : 38mins",
  },
  {
    id: 1,
    cover: "../images/rec/rec3.jpg",
    name: "My office Boss",
    time: "2hr : 38mins",
  },
  {
    id: 2,
    cover: "../images/rec/rec4.jpg",
    name: "Shadowe",
    time: "2hr : 38mins",
  },
  {
    id: 3,
    cover: "../images/upcome/u3.jpg",
    name: "Another Danger",
    time: "2hr : 38mins",
  },
]
